import '../../App.scss';
import '../../css/modals.scss';
import { getInvoicePaymentExportFields } from '../../helpers/exportFields';
import BaseCSVExportModal from './BaseCSVExportModal';
import {useParams} from "react-router-dom";
import {useContext} from "react";
import {BaseContext} from "../../helpers/common";

function InvoicePaymentsCSVExportModal(props) {
    let { facilityLink } = useParams();
    const { settings } = useContext(BaseContext);

    return (
        <BaseCSVExportModal
            {...props}
            fields={getInvoicePaymentExportFields(props.creditCardOption, settings)}
            filenamePrefix="Invoice-Payments-Report"
            cacheKey={facilityLink + "_csv_invoice_payments"}
            exportUrl={'/invoices/payments/export'} />
    );
}

export default InvoicePaymentsCSVExportModal;
